import { signInWithEmailAndPassword } from "firebase/auth";

import { auth, AuthAPI } from "../../auth";
import { CenterAPI, CenterInvitationAPI } from "../../center";

/** Whether an invitation token may be used to sign up a centre. */
export async function isCenterInvitationValid(token: string): Promise<boolean> {
    const { data } = await AuthAPI.validateInvitation(token);
    return data.valid && data.kind === "center";
}

/** Register the centre and its owner. Returns the owner's MFA enrolment. */
export async function registerCenter(payload: Parameters<typeof CenterAPI.registerCenter>[0]) {
    const { data } = await CenterAPI.registerCenter(payload);
    return data;
}

/** Open the new owner's session and send them the email verification link. */
export async function signInOwnerAndSendVerification(email: string, password: string): Promise<void> {
    const result = await signInWithEmailAndPassword(auth, email, password);
    await auth.updateCurrentUser(result.user);
    await AuthAPI.sendVerificationEmail(`${window.location.origin}/auth/action`);
}

export function hasSignedInUser(): boolean {
    return Boolean(auth.currentUser);
}

/** Reload the signed-in user and tell whether they have verified their email. */
export async function reloadEmailVerified(): Promise<boolean> {
    if (!auth.currentUser) return false;
    await auth.currentUser.reload();
    return auth.currentUser.emailVerified;
}

/** Turn on MFA for the signed-in owner. Returns the updated therapist. */
export async function enableOwnerMfa(totpCode: string) {
    if (!auth.currentUser) throw new Error("No user logged in");
    const { data } = await AuthAPI.mfaEnable({ totp_code: totpCode });
    // The session carries the MFA claim only once the ID token refreshes.
    await auth.currentUser.getIdToken(true);
    return data;
}

/** Join the centre the invitation is for. */
export async function acceptCenterInvitation(token: string) {
    const { data } = await CenterInvitationAPI.accept(token);
    return data;
}
